import axios from "axios";
import toastr from "toastr";
import * as actions from "./actionsTypes";
import errorManage from "../../errorManage";
import messages from "../../messages";
import campaniasServices from "./campaña.services";

export const getCAMPAÑA = (filters, userName) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CAMPAÑA,
      payload: true,
    });
    if (userName) {
      filters.tipo_busqueda = "responsable_codigo";
      filters.filter = userName;
    }
    const resp = await campaniasServices.getCampañas(filters, userName);
    dispatch({
      type: actions.GET_CAMPAÑA,
      payload: {
        campaña: resp.data.data,
        campañaLength: resp.data.count,
      },
    });
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_CAMPAÑA,
      payload: false,
    });
  }
};

export const getResponsables = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_RESPONSABLE,
      payload: true,
    });
    const resp = await campaniasServices.getResponsables(filters);
    dispatch({
      type: actions.GET_RESPONSABLE,
      payload: {
        responsable: resp.data.data,
      },
    });
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_RESPONSABLE,
      payload: false,
    });
  }
};

export const getResponsablesOtro = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_RESPONSABLE_OTRO,
      payload: true,
    });
    const resp = await campaniasServices.getResponsablesOtro(filters);
    dispatch({
      type: actions.GET_RESPONSABLE_OTRO,
      payload: {
        responsablesOtro: resp.data.data,
      },
    });
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_RESPONSABLE_OTRO,
      payload: false,
    });
  }
};

export const saveCampaña =
  (data, setShowModal, maintenance, history, userName) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_CAMPAÑA,
        payload: true,
      });
      const resp = await campaniasServices.saveCampaña(data);
      const { campaña, campañaLength } = getState().campaña;
      const aCampaña = [...campaña, resp.data];
      dispatch({
        type: actions.GET_CAMPAÑA,
        payload: {
          campaña: aCampaña,
          campañaLength: campañaLength + 1,
        },
      });
      setShowModal(false);
      toastr.success(messages.successMessage);
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      if (!maintenance) {
        history.push(`/campañas/responsable/${userName}`);
      }
      dispatch({
        type: actions.SAVE_LOADER_CAMPAÑA,
        payload: false,
      });
    }
  };

export const editCampaña =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_CAMPAÑA,
        payload: true,
      });
      const resp = await campaniasServices.editCampaña(id, data);
      const { campaña, campañaLength } = getState().campaña;
      campaña[index] = resp.data;
      dispatch({
        type: actions.GET_CAMPAÑA,
        payload: {
          campaña: campaña,
          campañaLength: campañaLength,
        },
      });
      setShowModal(false);
      toastr.success(messages.successMessage);
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      dispatch({
        type: actions.LOADING_CAMPAÑA,
        payload: false,
      });
    }
  };

export const deleteCampaña = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CAMPAÑA,
      payload: true,
    });
    await campaniasServices.deleteCampaña(id);
    const { campaña, campañaLength } = getState().campaña;
    campaña.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_CAMPAÑA,
      payload: {
        campaña: campaña,
        campañaLength: campañaLength - 1,
      },
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_CAMPAÑA,
      payload: false,
    });
  }
};

export const sendMail = (data) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CORREO,
      payload: true,
    });

    const resp = await campaniasServices.sendMail(data);
    dispatch({
      type: actions.SEND_SURVEY,
      payload: resp.data,
    });
    toastr.success(messages.campaniaSend);
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
          console.log(ex.response);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_CORREO,
      payload: false,
    });
  }
};

export const getSurvey = (params) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_SURVEY_CAMPAÑA,
      payload: true,
    });
    const resp = await campaniasServices.getSurvey(params);
    dispatch({
      type: actions.GET_SURVEY_CAMPAÑA,
      payload: {
        survey: resp.data.data,
        surveyLength: resp.data.count,
        enlace: "",
      },
    });
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_SURVEY_CAMPAÑA,
      payload: false,
    });
  }
};

export const generarEnlace =
  (params, setEnlace, setEnlaceLoading) => async () => {
    try {
      setEnlaceLoading(true);
      const resp = await campaniasServices.generateLink(params);
      setEnlace(resp.data.enlace_evaluacion);
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else if (ex.response.status === 404) {
          errorManage(ex);
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      setEnlaceLoading(false);
    }
  };

export const saveCampañaSegmento =
  (data, setShowModal, segmnt, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_CAMPAÑA,
        payload: true,
      });
      await campaniasServices.saveCampañaSegmento(data);
      const { campaña, campañaLength } = getState().campaña;
      let _segmnt = [];
      segmnt.map((item) =>
        _segmnt.push({
          segmento_id: item.id,
          segmento__nombre: item.label,
        })
      );
      campaña[index].segmento_list = _segmnt;
      dispatch({
        type: actions.GET_CAMPAÑA,
        payload: {
          campaña: campaña,
          campañaLength: campañaLength,
        },
      });
      setShowModal();
      toastr.success(messages.successMessage);
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_CAMPAÑA,
        payload: false,
      });
    }
  };

export const getSendData =
  (req, setData, setLoading, setError) => async (dispatch) => {
    try {
      setLoading(true);
      const resp = await campaniasServices.getSendData(req);
      setData(resp.data);
      setError("");
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              message = messages.notFound;
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      console.error(message);
      setError(message);
    } finally {
      setLoading(false);
    }
  };

export const sendSurveyEmployee =
  (req, data, setData, index, setLoadingSendSurvey) => async (dispatch) => {
    try {
      setLoadingSendSurvey(true);
      await campaniasServices.sendSurveyEmployee(req);
      let _data = data;
      _data.empleados_sin_encuesta.splice(index, 1);
      setData(_data);
      toastr.success(messages.campaniaSend);
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else if (ex.response.status === 404) {
          if (ex.response.data.mensaje) {
            toastr.info(ex.response.data.mensaje);
          } else {
            errorManage(ex);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      setLoadingSendSurvey(false);
    }
  };
